// extracted by mini-css-extract-plugin
export var homeHeroWrapper = "styles-module--homeHeroWrapper--eq1Mp";
export var image = "styles-module--image--rOzic";
export var textBlock = "styles-module--textBlock--d2ATW";